module.exports = __webpack_public_path__ + "static/media/close-icon.d81b4cbc.svg";